module.exports = __webpack_public_path__ + "img/lainaamo.a51a825.png";